import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingState from '../common/LoadingState';

export default function ProtectedRoute({ children, requiredRole = null }) {
  const { currentUser, userRole, ROLES, loading } = useAuth();
  const effectiveRole = userRole || currentUser?.role || ROLES.USER;

  if (loading && !currentUser) {
    return <LoadingState message="Loading session..." compact disableAnimation />;
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole) {
    // Check if user has the required role
    let hasAccess = false;

    // Handle array of roles
    if (Array.isArray(requiredRole)) {
      // User has access if they have any of the required roles
      requiredRole.forEach(role => {
        switch (role) {
          case 'admin':
            hasAccess = hasAccess || effectiveRole === ROLES.ADMIN;
            break;
          case 'manager':
            hasAccess = hasAccess || (effectiveRole === ROLES.ADMIN || effectiveRole === ROLES.MANAGER);
            break;
          default:
            hasAccess = hasAccess || true;
        }
      });
    } else {
      // Handle single role (string)
      switch (requiredRole) {
        case 'admin':
          hasAccess = effectiveRole === ROLES.ADMIN;
          break;
        case 'manager':
          hasAccess = effectiveRole === ROLES.ADMIN || effectiveRole === ROLES.MANAGER;
          break;
        default:
          hasAccess = true;
      }
    }

    if (!hasAccess) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return children;
}
